"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DealLabel: true,
  isDealLabel: true
};
Object.defineProperty(exports, "DealLabel", {
  enumerable: true,
  get: function () {
    return _DealLabel.DealLabel;
  }
});
Object.defineProperty(exports, "isDealLabel", {
  enumerable: true,
  get: function () {
    return _isDealLabel.isDealLabel;
  }
});
var _DealLabel = require("./DealLabel");
var _isDealLabel = require("./isDealLabel");
var _getDealLabel = require("./getDealLabel");
Object.keys(_getDealLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getDealLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDealLabel[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
